<div class="main-content ">
    <div class="main-heading">
        <strong translate>LINKS</strong>
    </div>
    <div class="card">
        <div class="card-body">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>